import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Form } from '../shared/form';
import { HttpErrorHandler } from '../shared/http-error-handler';

import { User } from '../_models/user';
import { AuthenticationService } from '../_services/authentication.service';
import { ProfileService } from '../_services/profile.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
})
export class LoginComponent extends Form implements OnInit {
  form: FormGroup;
  user: User;

  constructor(
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private profileService: ProfileService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);

    this.form = fb.group({
      username: '',
      password: '',
    });
  }

  ngOnInit() {
    this.user = new User();
  }

  onSubmit() {
    this.authenticationService.login(this.user).subscribe(
      (logged) => this.onLogin(logged),
      (error) => this.handleError(error)
    );
  }

  onLogin(logged) {
    this.profileService.profile().subscribe(
      (profile) => this.saveProfile(profile),
      (error) => this.handleError(error)
    );
  }

  saveProfile(profile) {
    this.profileService.saveProfile(profile);
    window.location.href = '/dashboard';
  }

  handleError(error) {
    const errors = this.httpErrorHandler.handleHttpError(error);
    this.parseApiErrors(errors, this.form);
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts